var exports = {
  "Zp": "Card__DUKtCs",
  "Lc": "CardHeading__OpuF6B",
  "N_": "Link__iRdl9b",
};

module.exports = exports;
